import { RichText } from "@graphcms/rich-text-react-renderer";

import { isAssetReferences } from "~/typings";

import type { NewsArticle } from "~/typings";

export default function ArticleContent({
	legacyContent,
	content,
}: Pick<NewsArticle, "legacyContent" | "content">): React.ReactNode {
	if (!!legacyContent) {
		return <div dangerouslySetInnerHTML={{ __html: legacyContent }} />;
	}
	if (!!content) {
		const references = isAssetReferences(content.references) ? content.references : [];

		return <RichText content={content.json} references={references} />;
	}

	return <p>nothing here</p>;
}
